import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { SHA256 } from "crypto-js";
import "../blockpay.css";
import Img from "../../images/Group 1171280553.svg";
import Logo from "../../images/logo 01.png";
import AppStore from "../../images/App Store.svg";
import Gplay from "../../images/Google Play.svg";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Unstable_Grid2";
import GoogleImg from "../../images/google.png";
import AppleImg from "../../images/apple.png";
import OtpModal from "./modals/otpModal";
import { setAuthToken } from "../../utils/setAuthToken";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import SignupPhone from '../../images/signup-phone.png'
import {
  Card,
  CardContent,
  TextField,
  Button,
  Box,
  Typography,
  InputAdornment,
} from "@mui/material";
import { Link } from "react-router-dom";
// import SignUpRadioBtns from "./Signup2/signupRadioBtn";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

export default function SignUp2() {
  // Radio button
  const [selectedOption, setSelectedOption] = useState("Business");
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  // Sign Up Form
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [pass2, setPass2] = useState("");
  const [phone, setPhone] = useState("");
  const [bussname, setBussname] = useState("");
  const calculateHash = (inputValue) => {
    const hashedValue = SHA256(inputValue).toString();
    return hashedValue;
  };
  const navigate = useNavigate();
  // Modal use State
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  //Password Hide/Show
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);

  //
  // Backdrop usestates and functions
  const [openbackdrop, setOpenbackdrop] = useState(false);
  const handleClosebd = () => {
    setOpenbackdrop(false);
  };
  const handleOpenbd = () => {
    setOpenbackdrop(true);
  };

  const handleMainLogoClick = () => {
    navigate("/");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setOpenbackdrop(true);
    axios
      .post("https://api.blockpay.co.za/merchant/signup", {
        firstname: firstname,
        lastname: lastname,
        email: email,
        password: calculateHash(pass),
        confirmPassword: calculateHash(pass2),
        businessName: bussname,
        phone: phone,
      })
      .then((res) => {
        handleClosebd();
        toast.success(res.data.message, { autoClose: 1000 });
        console.log(res.data);
        localStorage.setItem("email", email);
        setAuthToken(res.data.token);
        // navigate("/verify", { replace: true });
        handleOpen();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log(err);
        setTimeout(() => {
          handleClosebd();
        }, 2000);

        // if (err.response.data.message==="Email already exists"){
        //   handleOpen();
        // }
        if (err.response.data.message === "User already exists") {
          navigate("/signinpin", { replace: true });
        }
      });
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openbackdrop}
        onClick={handleClosebd}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          "@media (max-width:900px)": {
            display: "flex",
            justifyContent: "center!important",
          },
        }}
      >
        <img
          src={Logo}
          className="loginLogoImg"
          onClick={handleMainLogoClick}
          style={{ cursor: "pointer" }}
        />
      </Box>
      <Grid container className="loginGrid">
        <Grid
          xs={12}
          md={6}
          lg={6}
          sx={{
            display: { xs: "none", md: "grid", lg: "flex" },
            justifyContent: "flex-end",
          }}
        >
          <img src={Img} className="loginImg" />
        </Grid>
        <Grid xs={12} md={6} lg={6} className="loginGridCol2">
          <Box className="loginCard">
            <CardContent>
              <Box
                sx={{
                  fontSize: "h4.fontSize",
                  fontWeight: "bold",
                  marginBottom: 2,
                }}
              >
                Sign up
              </Box>
              <form onSubmit={handleSubmit}>
                <Box sx={{ display: "flex" }}>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      size="small"
                      value={selectedOption}
                      onChange={handleOptionChange}
                    >
                      <FormControlLabel
                        value="Personal"
                        control={<Radio size="small" />}
                        label="Personal"
                        // control={<Radio />}
                      />
                      <FormControlLabel
                        value="Business"
                        control={<Radio size="small" />}
                        label="Business"
                        // control={<Radio />}
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
                {selectedOption === "Business" && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      className="signupNameGrid"
                    >
                      <TextField
                        sx={{
                          flexGrow: 1,
                          width: 0,
                          marginRight: "1rem",
                          borderRadius: "50px!important",
                        }}
                        InputLabelProps={{ shrink: true }}
                        id="first-name"
                        label="First Name"
                        variant="outlined"
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                      <TextField
                        label="Last Name"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        sx={{ flexGrow: 1, width: 0 }}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </div>

                    <TextField
                      className="logintextField"
                      label="Email address"
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      type="email"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <TextField
                      className="logintextField"
                      label="Password"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Box
                              onClick={handleClickShowPassword}
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              {showPassword ? (
                                <Button
                                  sx={{
                                    textTransform: "none",
                                    color: "gray",
                                    paddingRight: "0",
                                  }}
                                >
                                  <VisibilityOffIcon
                                    fontSize="small"
                                    sx={{ marginRight: "5px" }}
                                  />
                                  <Typography
                                    sx={{
                                      fontWeight: "500",
                                    }}
                                  >
                                    Hide
                                  </Typography>
                                </Button>
                              ) : (
                                <Button
                                  sx={{
                                    textTransform: "none",
                                    color: "gray",
                                    paddingRight: "0",
                                  }}
                                >
                                  <VisibilityIcon
                                    fontSize="small"
                                    sx={{ marginRight: "5px" }}
                                  />
                                  <Typography
                                    sx={{
                                      fontWeight: "500",
                                    }}
                                  >
                                    Show
                                  </Typography>
                                </Button>
                              )}
                            </Box>
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                      type={showPassword ? "text" : "password"}
                      onChange={(e) => setPass(e.target.value)}
                      required
                    />
                    <TextField
                      className="logintextField"
                      label="Confirm Password"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Box
                              onClick={handleClickShowPassword2}
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              {showPassword2 ? (
                                <Button
                                  sx={{
                                    textTransform: "none",
                                    color: "gray",
                                    paddingRight: "0",
                                  }}
                                >
                                  <VisibilityOffIcon
                                    fontSize="small"
                                    sx={{ marginRight: "5px" }}
                                  />
                                  <Typography
                                    sx={{
                                      fontWeight: "500",
                                    }}
                                  >
                                    Hide
                                  </Typography>
                                </Button>
                              ) : (
                                <Button
                                  sx={{
                                    textTransform: "none",
                                    color: "gray",
                                    paddingRight: "0",
                                  }}
                                >
                                  <VisibilityIcon
                                    fontSize="small"
                                    sx={{ marginRight: "5px" }}
                                  />
                                  <Typography
                                    sx={{
                                      fontWeight: "500",
                                    }}
                                  >
                                    Show
                                  </Typography>
                                </Button>
                              )}
                            </Box>
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                      type={showPassword2 ? "text" : "password"}
                      onChange={(e) => setPass2(e.target.value)}
                      required
                    />
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      className="signupNameGrid"
                    >
                      <TextField
                        sx={{
                          flexGrow: 1,
                          width: 0,
                          marginRight: "1rem",
                          borderRadius: "50px!important",
                        }}
                        InputLabelProps={{ shrink: true }}
                        id="first-name"
                        label="Business name"
                        variant="outlined"
                        onChange={(e) => setBussname(e.target.value)}
                      />
                      <TextField
                        label="Phone no."
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        onChange={(e) => setPhone(e.target.value)}
                        sx={{ flexGrow: 1, width: 0 }}
                      />
                    </div>
                    <FormControlLabel
                      sx={{ color: "#666666" }}
                      required
                      control={<Checkbox />}
                      label="Agree with terms & conditions."
                    />
                    <Button
                      className="loginButtonSignUp"
                      variant="contained"
                      color="primary"
                      size="large"
                      type="submit"
                      disabled={pass === "" || !pass2}
                      sx={{ textTransform: "none", borderRadius: "10px" }}
                    >
                      <span className="buttonSignText">Signup</span>
                    </Button>
                  </>
                )}
                {selectedOption==="Personal" &&(<Box component="img" src={SignupPhone} sx={{height:"auto"}} />)}
                <OtpModal email={email} open={open} onClose={handleClose} />
              </form>
            </CardContent>
          </Box>
          {selectedOption === "Business" && (
            <>
              <Box className="loginCard2">
                <CardContent sx={{ fontSize: 19, padding: "10px!important" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#666666",
                    }}
                  >
                    <Box
                      component="img"
                      src={GoogleImg}
                      sx={{ height: "30px", marginRight: "1rem" }}
                    />{" "}
                    Continue with Google
                  </Box>
                </CardContent>
              </Box>
              <Box className="loginCard2">
                <CardContent sx={{ fontSize: 19, padding: "10px!important" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#666666",
                    }}
                  >
                    <Box
                      component="img"
                      src={AppleImg}
                      sx={{ height: "30px", marginRight: "1rem" }}
                    />{" "}
                    Continue with Apple
                  </Box>
                </CardContent>
              </Box>
              <Box sx={{ fontSize: "19px", marginTop: "2rem", mb: "1rem" }}>
                Already have an account?{" "}
                <span>
                  <Link to="/signinpin" className="underline">
                    Log in
                  </Link>
                </span>
              </Box>
            </>
          )}
          {selectedOption==="Personal" && (<Box className="loginCard3">
            <Grid container spacing={4} className="loginGrid1-2">
              <Grid
                xs={6}
                md={6}
                lg={6}
                sx={{ paddingRight: 1, paddingLeft: 0 }}
              >
                <img src={AppStore} className="loginAppImg" />
              </Grid>
              <Grid
                xs={6}
                md={6}
                lg={6}
                sx={{ paddingLeft: 1, paddingRight: "0!important" }}
              >
                <img src={Gplay} className="loginAppImg" />
              </Grid>
            </Grid>
          </Box>)}
        </Grid>
      </Grid>
    </>
  );
}
